const backgroundState = new WeakMap();

// Hides everything but `modal` from assistive technology and input while it is open. The modal must be
// a direct child of `<body>`; the previous `aria-hidden`/`inert` of each sibling is restored on close.
export const setBackgroundInert = (modal, isInert, documentRef = document) => {
    const bodyChildren = Array.from(documentRef.body?.children ?? []);
    bodyChildren.forEach((node) => {
        if (!(node instanceof HTMLElement) || node === modal) {
            return;
        }

        if (isInert) {
            backgroundState.set(node, {
                ariaHidden: node.getAttribute('aria-hidden'),
                inert: Boolean(node.inert),
            });
            node.setAttribute('aria-hidden', 'true');
            node.inert = true;
        } else {
            const previousState = backgroundState.get(node);
            if (previousState === undefined) {
                return;
            }

            if (previousState.ariaHidden === null) {
                node.removeAttribute('aria-hidden');
            } else {
                node.setAttribute('aria-hidden', previousState.ariaHidden);
            }

            node.inert = previousState.inert;
            backgroundState.delete(node);
        }
    });
};
